import { type JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { Text } from '@videoblocks/design-system';

export interface ModelSelectBadgeProps {
    version: string;
    className?: string;
    disabled?: boolean;
}

export function ModelSelectBadge({ version, className, disabled }: ModelSelectBadgeProps): JSX.Element {
    return (
        <div
            className={twMerge(
                'flex size-12 shrink-0 items-center justify-center rounded-sm',
                disabled && 'dark:bg-neutral-dark-600',
                className,
            )}
        >
            <Text fontSize="xs" fontWeight="semibold" className="text-center dark:text-neutral-dark-200">
                {version}
            </Text>
        </div>
    );
}
